<template>
  <div
    v-if="exts && exts.length > 1"
    class="tab-list"
  >
    <div class="container">
      <div
        v-if="
          Number(fitnessFlag) === 1 ||
            (packageFlag || dentistryFlag || healthgoodsFlag)
        "
        class="tab-list-items"
        @click="goSecond('/health/home', 1)"
      >
        <div class="tab-item">
          {{ TLang('首页','my') }}
        </div>
      </div>
      <div
        v-if="
          exts.includes(2) &&
            (packageFlag || dentistryFlag || healthgoodsFlag)
        "
        class="tab-list-items"
        @click="goSecond('/health/package/list', 1)"
      >
        <div class="tab-item">
          {{ TLang('体检预约','my') }}
        </div>
      </div>
      <div
        v-if="
          exts.includes(4) &&
            (packageFlag || dentistryFlag || healthgoodsFlag)
        "
        class="tab-list-items"
        @click="goSecond('/health/tooth/list', 1)"
      >
        <div class="tab-item">
          {{ TLang('口腔健康','my') }}
        </div>
      </div>

      <div
        v-if="
          exts.includes(5) &&
            (packageFlag || dentistryFlag || healthgoodsFlag)
        "
        class="tab-list-items active"
        @click="goSecond(`/shop/product/list`, 2)"
      >
        <div class="tab-item">
          {{ TLang('健康商城','my') }}
        </div>
      </div>
      <div
        v-if="
          exts.includes(3) &&
            (Number(fitnessFlag) === 1 ||
            (packageFlag || dentistryFlag || healthgoodsFlag))
        "
        class="tab-list-items"
        @click="goSecond('/health/customList', 1)"
      >
        <div class="tab-item">
          {{ TLang('企业定制','my') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { nav, getRecommendMould, getExistChannelCategory } from '@fetch/health';
import Cookies from 'js-cookie';
import { getQueryString, unionFlag } from '@utils';
import { healthChannelId } from '@utils/config';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      path: location.pathname,
      packageFlag: 0,
      dentistryFlag: 0,
      healthcareFlag: 0,
      healthgoodsFlag: 0,
      fitnessFlag: 0,
      exts: [],
      city: Cookies.get('address') && JSON.parse(Cookies.get('address')).cityId || getQueryString('city'),
      bannerList: [],
    };
  },
  watch: {
    $route: {
      handler(a) {
        this.path = a.path;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getHomeIndex();
  },
  methods: {
    ...mapActions('shopCart', [
      'changeExts',
      'changeMallgoodsList'
    ]),
    getHomeIndex() {
      nav({city:this.city}).then(res => {
        this.fitnessFlag = res.fitnessFlag;
        // this.exts = res.exts || [];
        this.bannerList = res.bannerList || [];
        // this.changeExts(this.exts);
        // this.getList();
      });
      //从百福德新接口获取 频道数据，官网频道数据写死
      let union = unionFlag();
      if(window.df_sdk_common.isBfd()){
        getExistChannelCategory({union}).then(res => {
          if(res && res.value){
            const arr = res.value.map(item => item.categoryName);
            const list = [];
            // if(arr.includes('首页')){
            //   list.push(0);
            // }
            if(arr.includes('体检预约')){
              list.push(2);
            }
            if(arr.includes('口腔健康')){
              list.push(4);
            }
            if(arr.includes('健康商城')){
              list.push(5);
            }
            if(arr.includes('企业定制')){
              list.push(3);
            }
            console.log('频道数据  新版',list);
            this.exts = list;
            this.changeExts(this.exts);
            this.getList();
          }
        });
      }else{
        this.exts = [2,3,4,5];
        this.changeExts(this.exts);
        this.getList();
      }
    },
    getList() {
      getRecommendMould({city:this.city}).then(res => {
        const data = res;
        this.packageFlag = data.packageFlag;
        this.dentistryFlag = data.dentistryFlag;
        this.healthcareFlag = data.healthcareFlag;
        this.healthgoodsFlag = data.healthgoodsFlag;
        this.changeMallgoodsList(this.healthgoodsFlag);
        if((!this.exts.includes(2) || !this.packageFlag) &&(!this.exts.includes(4) || !this.dentistryFlag) &&(!this.exts.includes(5) || !this.healthgoodsFlag) &&(!this.exts.includes(1) ||(this.bannerList.length &&this.fitnessFlag != 1) ||!this.bannerList.length)) {
          window.df_sdk_common.location.href = decodeURIComponent(`/health/home?city=${this.city}${unionFlag() ? '&union=' + unionFlag() : ''}`);
        }
      });
    },
    goSecond(path, type) {
      let url = path + (type===1 ? `?city=${this.city}${unionFlag() ? '&union=' + unionFlag() : ''}` : `?categoryId=&channelId=${healthChannelId}`);
      window.df_sdk_common.location.href = decodeURIComponent(url);
    },
  },
};
</script>
<style lang="less" scoped>
.tab-list {
  width: 100%;
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  .container {
    .wrapper();
  }
  .tab-list-items {
    display: inline-block;
    width: 19%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #333;
    font-size: 18px;
    cursor: pointer;
    position: relative;
    .tab-item {
      position: absolute;
      left: 0;
      width: 100%;
      margin: 0 auto;
      &::after {
        position: absolute;
        content: "";
        height: 3px;
        width: 72px;
        background: #fff;
        bottom: -4px;
        left: 50%;
        margin-left: -36px;
      }
      > i {
        position: relative;
        top: -2px;
        display: inline-block;
        vertical-align: middle;
        width: 30px;
        height: 30px;
        margin-right: 4px;
        background-size: 30px 30px;
      }
    }
    &.active {
      color:#3FA6FF;
      color: var(--df-primary-color, #3FA6FF);
      transition: all 0.3s ease-in-out;
      font-weight: bold;
      .tab-item::after {
        background: #3FA6FF;
        background: var(--df-primary-color, #3FA6FF);
      }
    }
    &:hover {
      color:#3FA6FF;
      color: var(--df-primary-color, #3FA6FF);
      font-weight: bold;
    }
  }
  .tab-list-items:first-child .tab-item::after {
    width: 36px;
    margin-left: -18px;
  }
}
</style>
